import * as types from './mutation-types'

export default {
  [types.ADD_ACTIVITY_TYPES](state, data) {
    state.types = data.data
  },
  [types.ADD_ACTIVITY_TYPE] (state, data) {
    state.types.push(data)
  },
  [types.ADD_ACTIVITY_ICONS] (state, data) {
    let array = []
    array.push(...data)
    state.icons = array
  },
}
